import declare from "dojo/_base/declare";
import StoreValuePairsConstructor from "./ValuePairs";

const DataStoreValuePairs = declare(StoreValuePairsConstructor, {
	requestModule: "DataStore",
	requestOperation: "GetValuePairs",
});

export = DataStoreValuePairs;